import FormTransferSvg from './form-transfer.svg';
import ZcashPNG from './zcash.png';
import ZcashYellowPNG from './zcash-yellow.png';
import ZcashBrandmarkPNG from './zcash-brandmark.png';
import NearIconPNG from './near-icon.png';
import StarknetSymbolPNG from './starknet-symbol.png';
import StarknetStackedPNG from './starknet-stacked.png';
import LetheFaviconPNG from './lethe_favicon.png';
import LetheLogoPNG from './lethe_logo_nobackground.png';

// Icons
import ArrowReceiveSvg from './icons/arrow-receive.svg';
import ArrowTransferSvg from './icons/arrow-transfer.svg';
import ClockSvg from './icons/clock.svg';
import ShieldSvg from './icons/shield.svg';
import ShieldDividedSvg from './icons/shield-divided.svg';
import SummarySvg from './icons/summary.svg';
import CoinsSvg from './icons/coins.svg';
import ChevronSVG from './icons/chevron.svg';
import CheckSVG from './icons/check.svg';
import WarningSVG from './icons/warning.svg';
import EyeSvg from './icons/eye.svg';
import EyeSlashSvg from './icons/eye-slash.svg';
import CircleSvg from './icons/circle.svg';
import CircleDashedSvg from './icons/circle-dashed.svg';

export {
  ZcashPNG,
  ZcashYellowPNG,
  ZcashBrandmarkPNG,
  NearIconPNG,
  FormTransferSvg,
  StarknetSymbolPNG,
  StarknetStackedPNG,
  LetheFaviconPNG,
  LetheLogoPNG,
  ArrowReceiveSvg,
  ArrowTransferSvg,
  ClockSvg,
  ShieldSvg,
  ShieldDividedSvg,
  SummarySvg,
  CoinsSvg,
  ChevronSVG,
  CheckSVG,
  WarningSVG,
  EyeSvg,
  EyeSlashSvg,
  CircleSvg,
  CircleDashedSvg,
};
